import { useState } from 'react';

export const useCellSelection = () => {
  const [selectedCells, setSelectedCells] = useState([]);
  const [selectionStart, setSelectionStart] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [dragField, setDragField] = useState(null);

  const handleCellMouseDown = (e, rowIndex, field) => {
    if (e.metaKey || e.ctrlKey) {
      // Handle cmd/ctrl+click for individual selection
      const exists = selectedCells.some(cell => 
        cell.rowIndex === rowIndex && cell.field === field
      );
      
      if (exists) {
        setSelectedCells(selectedCells.filter(cell => 
          !(cell.rowIndex === rowIndex && cell.field === field)
        ));
      } else {
        setSelectedCells([...selectedCells, { rowIndex, field }]);
      }
      setSelectionStart({ rowIndex, field });
    } else {
      // Regular click - start new selection
      setSelectedCells([{ rowIndex, field }]);
      setSelectionStart({ rowIndex, field });
      setIsDragging(true);
      setDragField(field);
    }
  };

  const handleCellMouseEnter = (rowIndex, field) => {
    if (isDragging && field === dragField) {
      const start = selectionStart.rowIndex;
      const end = rowIndex;
      const startRow = Math.min(start, end);
      const endRow = Math.max(start, end);
      
      const newSelection = [];
      for (let i = startRow; i <= endRow; i++) {
        newSelection.push({ rowIndex: i, field });
      }
      setSelectedCells(newSelection);
    }
  };

  const handleCellMouseUp = () => {
    setIsDragging(false);
    setDragField(null);
  };

  const clearSelection = () => {
    setSelectedCells([]);
    setSelectionStart(null);
  };

  return {
    selectedCells,
    isDragging,
    dragField,
    handleCellMouseDown,
    handleCellMouseEnter,
    handleCellMouseUp,
    clearSelection
  };
};
